module.exports = __webpack_public_path__ + "static/media/triot_stage.0e7bb453.jpg";